import { useState, useContext } from 'react';
import { Flex, Group, SegmentedControl, Menu, Button, Anchor } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { CAMEL_TYPES } from 'constants/menuManagement';
import { ChevronDownIconXs } from '@chownow/pantry/icons';
import { MenuMappingContext } from './MenuMapping';

import MappingGuideModal from './Modals/MappingGuideModal';
import ActionConfirmationModal from './Modals/ActionConfirmationModal';

interface PanelHeaderProps {
  visibleTab: string;
  handleTabChange: (value: string) => void;
}

export default function PanelHeader({ visibleTab, handleTabChange }: PanelHeaderProps) {
  const [selectedAction, setSelectedAction] = useState<string>('');
  const [guideOpened, guideHandlers] = useDisclosure(false);
  const [confirmationOpened, confirmationHandlers] = useDisclosure(false, {
    onClose: () => setSelectedAction(''),
  });

  const { allowSelectionCheckbox } = useContext(MenuMappingContext);

  const actionItems = ['Map all unmapped items', 'Map all items', 'Unmap all items'];

  const onActionClick = (action: string) => {
    setSelectedAction(action);
    confirmationHandlers.open();
  };

  return (
    <>
      <Flex justify="space-between">
        <Group gap="md">
          <SegmentedControl
            size="sm"
            value={visibleTab}
            data={[
              { label: 'ITEMS', value: CAMEL_TYPES.items },
              { label: 'MODIFIERS', value: CAMEL_TYPES.modifiers },
            ]}
            onChange={handleTabChange}
            w={212}
          />
          {visibleTab === CAMEL_TYPES.modifiers && allowSelectionCheckbox()}
        </Group>
        <Group gap="sm">
          <Anchor
            component="button"
            variant="sublabel"
            size="sm"
            underline="always"
            onClick={guideHandlers.open}
          >
            Mapping Guide
          </Anchor>
          <Menu position="bottom-end">
            <Menu.Target>
              <Button variant="outline" size="md" rightSection={<ChevronDownIconXs />}>
                Actions
              </Button>
            </Menu.Target>
            <Menu.Dropdown>
              {actionItems.map((action, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Menu.Item onClick={() => onActionClick(action)} key={`action-item-${index}`}>
                  {action}
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Flex>
      <MappingGuideModal opened={guideOpened} close={guideHandlers.close} />
      <ActionConfirmationModal
        opened={confirmationOpened}
        close={confirmationHandlers.close}
        action={selectedAction}
      />
    </>
  );
}
